// Use shared base API for endpoint injection
import { api } from '../middleware/api';

export const hkreportsApi = api.injectEndpoints({
  endpoints: builder => ({
    getHKStocks: builder.query<any, { cid: string; fdt: string; tdt: string }>({
      query: ({ cid, fdt, tdt }) => `hkreports/stock/${cid}/${fdt}/${tdt}`
    }),
    getHKCounterStocks: builder.query<any, { cid: string; fdt: string; tdt: string }>({
      query: ({ cid, fdt, tdt }) => `hkreports/laundrystock/${cid}/${fdt}/${tdt}`
    }),
    getHKRoomStatusSummary: builder.query<any, { cid: string; date: string }>({
      query: ({ cid, date }) => `hkreports/room-status-summary/${cid}/${date}`
    }),
    getHKIndents: builder.query<any, { cid: string; fdt: string; tdt: string }>({
      query: ({ cid, fdt, tdt }) => `hkreports/indents/${cid}/${fdt}/${tdt}`
    }),
    getHKIssues: builder.query<any, { cid: string; fdt: string; tdt: string }>({
      query: ({ cid, fdt, tdt }) => `hkreports/issues/${cid}/${fdt}/${tdt}`
    }),
    getHKLaundryIn: builder.query<any, { cid: string; fdt: string; tdt: string }>({
      query: ({ cid, fdt, tdt }) => `hkreports/laundryin/${cid}/${fdt}/${tdt}`
    }),
    getHKLaundryOut: builder.query<any, { cid: string; fdt: string; tdt: string }>({
      query: ({ cid, fdt, tdt }) => `hkreports/laundryout/${cid}/${fdt}/${tdt}`
    })
  }),
  overrideExisting: false
});

export const {
  useGetHKStocksQuery,
  useGetHKCounterStocksQuery,
  useGetHKRoomStatusSummaryQuery,
  useGetHKIndentsQuery,
  useGetHKIssuesQuery,
  useGetHKLaundryInQuery,
  useGetHKLaundryOutQuery
} = hkreportsApi;
